import { render, staticRenderFns } from "./LeadTravelDetails.vue?vue&type=template&id=71611104&scoped=true&"
import script from "./LeadTravelDetails.vue?vue&type=script&lang=js&"
export * from "./LeadTravelDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadTravelDetails.vue?vue&type=style&index=0&id=71611104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71611104",
  null
  
)

export default component.exports